import { useCallback } from 'react'
import { ApiAccess } from 'features/session/types'
import { CancelToken } from 'axios'
import {
	ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	personApiBy
} from 'interface/endpoints'
import {
	LogResultList,
	TimesResultList,
	TagStatsResult,
	LogCondition,
	ServicesResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

export const useListWebLog = (
	personalId: string | undefined | null,
	{ service, hour, weekDay, days, offset, limit }: LogCondition & {
		offset: number | undefined
		limit: number | undefined
	}
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!personalId) return null
      return ApiGetWithToken<LogResultList>(
        apiAccess,
				personApiBy(personalId, '/log', {
					t,
					service: service?.join(','),
					hour: hour?.map(h => `${h}`).join(','),
					weekDay: weekDay?.map(w => `${w}`).join(','),
					offset,
					limit,
					days
				}),
        cancelToken
      )
    },
		[personalId, service, hour, weekDay, offset, limit, days]
	)
)

export const WebLogTimes = (
	apiAccess: ApiAccess,
	personalId: string,
	cancelToken?: CancelToken
) => ApiGetWithToken<TimesResultList>(
	apiAccess,
	personApiBy(personalId, '/times'),
	cancelToken
)
export const useListWebLogTimes = (
	personalId: string | undefined | null,
	service: string[] | undefined,
	days?: number
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!personalId) return null
      return ApiGetWithToken<TimesResultList>(
        apiAccess,
				personApiBy(personalId, '/times', {
					t,
					service: service?.join(','),
					days
				}),
        cancelToken
      )
    },
		[personalId, service, days]
	)
)

export const useListWebLogService = (
	personalId: string | undefined | null,
	hour: number[] | undefined,
	weekDay: string[] | undefined,
	days?: number
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!personalId) return null
      return ApiGetWithToken<ServicesResultList>(
        apiAccess,
				personApiBy(personalId, '/services', {
					t,
					hour: hour?.map(h => `${h}`).join(','),
					weekDay: weekDay?.map(w => `${w}`).join(','),
					days
				}),
        cancelToken
      )
    },
		[personalId, hour, weekDay, days]
	)
)

export const getWebLogTags = (
	apiAccess: ApiAccess,
	personalId: string,
	cancelToken?: CancelToken
) => ApiGetWithToken<TagStatsResult>(
	apiAccess,
	personApiBy(personalId, '/tags'),
	cancelToken
)
export const useWebLogTags = (
	personalId: string | undefined | null,
	{ service, hour, weekDay, days }: LogCondition
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!personalId) return null
      return ApiGetWithToken<TagStatsResult>(
        apiAccess,
				personApiBy(personalId, '/tags', {
					t,
					service: service?.join(','),
					hour: hour?.map(h => `${h}`).join(','),
					weekDay: weekDay?.map(w => `${w}`).join(','),
					days
				}),
        cancelToken
      )
    },
		[personalId, service, hour, weekDay, days]
	)
)
